import { array, mixed, object, string } from "yup"
import { ID } from "./yup.common"

export default object({
  id: ID,
  departmentType: mixed().label("Department Type").required(),
  preferredDepot: mixed().label("Preffered Depot"),
  name: string()
    .min(2, "Department name cannot be less than 2 characters!")
    .max(30, "Department Name should not exceed 30 characters!")
    .label("Department Name")
    .required(),
  varieties: array(mixed()),
  photo: mixed(),
})
